import type { ChatPromptContextEntityType } from './entities.js';
import type { ChatPromptContextResourceType } from './resources.js';

export interface ChatPromptContextEntity {
  /**
   * Id da entidade no Flux. Ausente para `screen`.
   */
  id?: string;
  /**
   * Rótulo legível (nome do fluxo/card/etapa) exibido ao usuário.
   */
  label?: string;
  type: ChatPromptContextEntityType;
}

/**
 * Recurso consultável disponível no que está em foco. Diferente de uma entidade:
 * não é onde o usuário está, é o que existe ali para a Iara abrir.
 */
export interface ChatPromptContextResource {
  /**
   * Id do recurso no Flux, para a Iara buscá-lo via tools.
   */
  id: string;
  type: ChatPromptContextResourceType;
}

export interface ChatPromptContext {
  entities: ChatPromptContextEntity[];
  /**
   * Recursos disponíveis no contexto em foco. Preenchido pela API (o client não
   * envia): ver `CHAT_PROMPT_CONTEXT_RESOURCES`.
   */
  resources?: ChatPromptContextResource[];
  /**
   * Caminho da rota sem query string, para rastreabilidade.
   */
  route?: string;
  /**
   * Rótulo da tela/aba (ex.: 'Fluxo — Quadro').
   */
  screen?: string;
}

/**
 * Chave dentro de `chat_messages.metadata` onde o contexto é persistido.
 */
export const CHAT_PROMPT_CONTEXT_METADATA_KEY = 'promptContext';

export const CHAT_PROMPT_CONTEXT_MAX_ENTITIES = 8;
export const CHAT_PROMPT_CONTEXT_MAX_RESOURCES = 4;
export const CHAT_PROMPT_CONTEXT_MAX_LABEL_CHARS = 200;
export const CHAT_PROMPT_CONTEXT_MAX_SCREEN_CHARS = 120;
export const CHAT_PROMPT_CONTEXT_MAX_ROUTE_CHARS = 300;
